import { render, staticRenderFns } from "./ComposableOctagonBrick.vue?vue&type=template&id=64225056&scoped=true&"
import script from "./ComposableOctagonBrick.vue?vue&type=script&lang=js&"
export * from "./ComposableOctagonBrick.vue?vue&type=script&lang=js&"
import style0 from "../../Style/composable-octagon-brick.scss?vue&type=style&index=0&id=64225056&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64225056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64225056')) {
      api.createRecord('64225056', component.options)
    } else {
      api.reload('64225056', component.options)
    }
    module.hot.accept("./ComposableOctagonBrick.vue?vue&type=template&id=64225056&scoped=true&", function () {
      api.rerender('64225056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Menu/ComposableOctagonBrick.vue"
export default component.exports